import { OnboardingNewBranchFormType } from 'src/pages/auth/OnboardingNewBranch/types';
import { call } from '../@';

export type AddCompanyBranchDto = { companyId: string; emails: string[] } & Omit<OnboardingNewBranchFormType, 'email'>;
export type AddCompanyBranchResponse = { id: string };

export default async function addCompanyBranch(dto: AddCompanyBranchDto) {
	return await call('company-branch-add', dto);
}
